import React from "react";

import LegalDialog from "./LegalDialog";
import LegalDocumentContent from "./LegalDocumentContent";

interface PrivacyPolicyModalProps {
  open: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <LegalDialog
      open={open}
      onClose={onClose}
      title="Privacy Policy"
      maxWidth="sm"
    >
      <LegalDocumentContent type="privacy" />
    </LegalDialog>
  );
};

export default PrivacyPolicyModal;
